import { DECLINE_DAY } from 'src/Constants';
import { declineWordByNumber } from 'src/Utils/declineWordByNumber';
import { FC } from 'react';
import Badge from '../Badge';
import moment from 'moment';
import st from './DateBadge.module.scss';

interface IDateBadgeProps {
	/** Дата */
	date: Date | string;
	/** Отключить цветовую индикацию */
	noColor?: boolean;
}

const getDayText = (diff: number): string => {
	if (diff === 0) {
		return 'Сегодня';
	}
	if (diff > 30) {
		return 'Более месяца назад';
	}
	if (diff > 7) {
		return 'Более недели назад';
	}
	if (diff === 1) {
		return 'День назад';
	}

	return `${diff} ${declineWordByNumber(diff, DECLINE_DAY)} назад`;
};

const DateBadge: FC<IDateBadgeProps> = ({ date, noColor = false }) => {
	const now = moment(moment.now()).set('hour', 0).set('milliseconds', 0);
	const dueDate = moment(date).set('milliseconds', 0);
	const diff = now.diff(dueDate, 'days');

	const getColor = () => {
		if (noColor) {
			return 'white';
		}

		if (diff > 7) {
			return 'red';
		} else if (diff >= 3) {
			return 'yellow';
		}
	};

	return (
		<Badge
			className={st.badge}
			align="center"
			color={getColor()}
			pill
			hint={dueDate.format('DD.MM.YYYY, HH:mm')}
		>
			{getDayText(diff)}
		</Badge>
	);
};

export default DateBadge;
